export const relativeTimeCheckIntervalMS = 5000
